import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import MainLayout from './layouts/MainLayout';
import Dashboard from './components/dashboard/Dashboard';
import CategoryList from './components/categories/CategoryList';
import Login from './components/auth/Login';
import PrivateRoute from './components/PrivateRoute';
import SongModels from './components/song-models/SongModels';
import GenreSettings from './components/settings/GenreSettings';
import MoodSettings from './components/settings/MoodSettings';
import ConfigSettings from './components/settings/ConfigSettings';
import ErrorLogs from './components/common/ErrorLogs';
import SyncRequestLogs from './components/sync-request-logs/SyncRequestLogs';
import MobileActivityLogs from './components/mobile-activity-logs/MobileActivityLogs';
import ProductList from './components/products/ProductList';
import TaskManager from './components/tasks/TaskManager';
import Statistics from './components/statistics/Statistics';
import SyncUsers from './components/sync-users/SyncUsers';
import AppleTransfer from './components/apple-transfer/AppleTransfer';
import ExploreOverview from './components/explore/ExploreOverview';
import ExplorePublicSongs from './components/explore/ExplorePublicSongs';
import ExplorePlaylists from './components/explore/ExplorePlaylists';
import ExploreNewReleases from './components/explore/ExploreNewReleases';
import ExploreTopCharts from './components/explore/ExploreTopCharts';
import ExploreMoodsGenres from './components/explore/ExploreMoodsGenres';
import SongCertificatesAdmin from './components/certificates/SongCertificatesAdmin';
import AdminPlaylists from './components/explore/AdminPlaylists';

import Devices from './components/devices/Devices';
import DeviceDetail from './components/devices/DeviceDetail';
import Payments from './components/payments/Payments';
import PaymentAdminRoute from './components/common/PaymentAdminRoute';
function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            
            {/* Protected Routes */}
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<MainLayout><Dashboard /></MainLayout>} />
              <Route path="/dashboard" element={<MainLayout><Dashboard /></MainLayout>} />
              <Route path="/song-models" element={<MainLayout><SongModels /></MainLayout>} />
              <Route path="/categories" element={<MainLayout><CategoryList /></MainLayout>} />
              <Route path="/products" element={<MainLayout><ProductList /></MainLayout>} />
              <Route path="/tasks" element={<MainLayout><TaskManager /></MainLayout>} />
              <Route path="/song-certificates" element={<MainLayout><SongCertificatesAdmin /></MainLayout>} />
              <Route path="/sync-users" element={<MainLayout><SyncUsers /></MainLayout>} />
              <Route path="/apple-transfer" element={<MainLayout><AppleTransfer /></MainLayout>} />
              <Route path="/devices" element={<MainLayout><Devices /></MainLayout>} />
              <Route path="/devices/detail" element={<MainLayout><DeviceDetail /></MainLayout>} />
              <Route
                path="/payments"
                element={
                  <MainLayout>
                    <PaymentAdminRoute>
                      <Payments />
                    </PaymentAdminRoute>
                  </MainLayout>
                }
              />
              <Route path="/settings/genres" element={<MainLayout><GenreSettings /></MainLayout>} />
              <Route path="/settings/moods" element={<MainLayout><MoodSettings /></MainLayout>} />
              <Route path="/settings/config" element={<MainLayout><ConfigSettings /></MainLayout>} />
              <Route path="/logs" element={<MainLayout><ErrorLogs /></MainLayout>} />
              <Route path="/sync-request-logs" element={<MainLayout><SyncRequestLogs /></MainLayout>} />
              <Route path="/mobile-activity-logs" element={<MainLayout><MobileActivityLogs /></MainLayout>} />
              {/* Explore */}
              <Route path="/explore" element={<Navigate to="/explore/overview" replace />} />
              <Route path="/explore/overview" element={<MainLayout><ExploreOverview /></MainLayout>} />
              <Route path="/explore/public-songs" element={<MainLayout><ExplorePublicSongs /></MainLayout>} />
              <Route path="/explore/playlists" element={<MainLayout><ExplorePlaylists /></MainLayout>} />
              <Route path="/explore/new-releases" element={<MainLayout><ExploreNewReleases /></MainLayout>} />
              <Route path="/explore/top-charts" element={<MainLayout><ExploreTopCharts /></MainLayout>} />
              <Route path="/explore/moods-genres" element={<MainLayout><ExploreMoodsGenres /></MainLayout>} />
              <Route path="/explore/admin-playlists" element={<MainLayout><AdminPlaylists /></MainLayout>} />
            </Route>

            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App; 